import PropTypes from "prop-types";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { A } from "@components/Anchor";
import { resolveStoreIsOpen } from "./lib/resolve-store-open";
import { to12HourClock } from "./lib/resolve-time";
import { STOREPROPTYPES } from "./lib/constants";
import styles from "@components/Typography/typography.module.css";
import cardStyles from "./styles/card.module.css";

function ListHours(store) {
  if (store.openingHours) {
    return store.openingHours.map((hours) => {
      if (hours.day.length > 1) {
        return (
          <p className={styles.paragraph} key={hours._key}>{`${hours.day[0]}-${
            hours.day[hours.day.length - 1]
          }: ${to12HourClock(hours.opensAt)}-${to12HourClock(hours.closesAt)}`}</p>
        );
      }
      return (
        <p className={styles.paragraph} key={hours._key}>{`${hours.day[0]}: ${to12HourClock(
          hours.opensAt
        )}-${to12HourClock(hours.closesAt)}`}</p>
      );
    });
  }

  return null;
}

function getCurbsideLink(store) {
  let href = "/";
  if (store.slug.current === "montreal") {
    href = "/montreal-product";
  } else if (store.slug.current === "toronto") {
    href = "/toronto-product";
  }
  return (
    <Link href={href} passHref>
      <A underline>Shop curbside pickup</A>
    </Link>
  );
}

export function StoreCardHours({ isIndex, store }) {
  const { t } = useTranslation("store");
  if (!store) {
    return null;
  }
  const isOpen = resolveStoreIsOpen(store);
  const wrapperStyle = `${cardStyles.hoursWrapper} ${isIndex ? cardStyles.hoursWrapperIndex : ""}`;
  return (
    <div className={wrapperStyle} isIndex={isIndex}>
      <div className={cardStyles.section}>
        <p className={styles.paragraph}>
          {t("hours")}: {!store.specialHours && (isOpen ? `(${t("open")})` : `(${t("closed")})`)}
        </p>
        {ListHours(store)}
        {store.specialHours && <p className={styles.paragraph}>{store.specialHours}</p>}
      </div>
    </div>
  );
}

StoreCardHours.propTypes = {
  isIndex: PropTypes.bool,
  store: STOREPROPTYPES.isRequired,
};

StoreCardHours.defaultProps = {
  isIndex: false,
};
